import { EventService as e } from "@perxis-auto/shared";
import { APP_ANALYTIC_EVENTS as n, APP_EVENTS_CHANNEL as t } from "../../config/events.js";
const o = new e({ eventChannel: t, analyticEvents: n });
export {
  o as eventService
};
